export enum EventTypeId {
  AMERICAN_FOOTBALL = 6423,
  ATHLETICS = 3988,
  AUSTRALIAN_RULES = 61420,
  BADMINTON = 627555,
  BACKGAMMON = 1938544,
  BASKETBALL = 7522,
  BASEBALL = 7511,
  BANDY = 998919,
  BEACH_SOCCER = 28361979,
  BEACH_VOLLEYBALL = 2872194,
  BOWLS = 998918,
  BOXING = 6,
  BRIDGE = 982477,
  CHESS = 136332,
  CRICKET = 4,
  COMMONWEALTH_GAMES = 300000,
  CURRENT_AFFAIRS = 27388198,
  CYCLING = 11,
  CURLING = 28578623,
  DARTS = 3503,
  DIVING = 28608996,
  E_SPORTS = 27454571,
  FINANCIAL_BETS = 6231,
  FISHING = 3088925,
  FLOORBALL = 998920,
  FUTSAL = 15826206,
  GAELIC_GAMES = 2152880,
  HANDBALL = 468328,
  HOCKEY = 7523,
  ICE_HOCKEY = 7524,
  INTERNATIONAL_RULES = 678378,
  GOLF = 3,
  GREYHOUND_RACING = 4339,
  GYMNASTICS = 28347302,
  HORSE_RACING = 7,
  LOTTERIES = 29125756,
  MOTOR_SPORT = 8,
  NETBALL = 606611,
  OLYMPICS_2016 = 27589895,
  POOL = 72382,
  POKER = 315220,
  RUGBY_LEAGUE = 1477,
  RUGBY_UNION = 5,
  PELOTA = 5412697,
  POLITICS = 2378961,
  ROWING = 12,
  SHOOTING = 28609007,
  SOCCER = 1,
  SPECIAL_BETS = 10,
  SQUASH = 4609466,
  SNOOKER = 6422,
  SWIMMING = 620576,
  TABLE_TENNIS = 2593174,
  TENNIS = 2,
  TRIATHLON = 27065662,
  SURFING = 4726642,
  VOLLEYBALL = 998917,
  WATER_POLO = 2901849,
  MIXED_MARTIAL_ARTS = 26420387,
  WEIGHTLIFTING = 28361982,
  WINTER_SPORTS = 451485,
  WINTER_OLYMPICS = 27105927,
  WRESTLING = 27485048,
  YACHTING = 998916
}
